/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_PlayerPrint_PlayerPrint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/PlayerPrint/PlayerPrint */ "./resources/scripts/components/PlayerPrint/PlayerPrint.ts");
/* harmony import */ var _components_GiftWithProduct_GiftWithProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/GiftWithProduct/GiftWithProduct */ "./resources/scripts/components/GiftWithProduct/GiftWithProduct.ts");
/* harmony import */ var _components_InventoryInfo_InventoryInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/InventoryInfo/InventoryInfo */ "./resources/scripts/components/InventoryInfo/InventoryInfo.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable */



customElements.define('player-print', _components_PlayerPrint_PlayerPrint__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define('inventory-info', _components_InventoryInfo_InventoryInfo__WEBPACK_IMPORTED_MODULE_1__["default"]);
var giftWithProduct = new _components_GiftWithProduct_GiftWithProduct__WEBPACK_IMPORTED_MODULE_2__["default"]();
giftWithProduct.init();
function fetchProductAndUpdateButton() {
  return _fetchProductAndUpdateButton.apply(this, arguments);
}
function _fetchProductAndUpdateButton() {
  _fetchProductAndUpdateButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var productUrl, response, data, variants, selectedVariant, wishlistButton, localWishlistItems, wishlistItems, newAttributes, attributesObject, exists;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          productUrl = window.productUrl;
          console.log(productUrl);
          _context4.prev = 2;
          _context4.next = 5;
          return fetch("".concat(productUrl, ".json"));
        case 5:
          response = _context4.sent;
          _context4.next = 8;
          return response.json();
        case 8:
          data = _context4.sent;
          if (response.ok) {
            variants = data.product.variants; // get the selected variant based on the currenty url - Checking for ?=variant and splitting the url to get the variant id
            selectedVariant = variants.filter(function (variant) {
              return window.location.href.includes("variant=".concat(variant.id));
            }); // update the wishlist button with the new variant
            wishlistButton = document.querySelector('wishlist-button');
            wishlistButton.dataset.title = "".concat(data.product.title);
            wishlistButton.dataset.id = selectedVariant[0].id;
            wishlistButton.dataset.price = selectedVariant[0].price;
            // check if the wishlist button attributes
            localWishlistItems = localStorage.getItem('wishlistItems');
            wishlistItems = JSON.parse(localWishlistItems);
            newAttributes = wishlistButton.dataset;
            attributesObject = Object.assign({}, newAttributes);
            exists = wishlistItems === null || wishlistItems === void 0 ? void 0 : wishlistItems.some(function (item) {
              return item.id === attributesObject.id;
            });
            if (!exists) {
              wishlistButton.classList.remove('is-animating');
            } else {
              wishlistButton.classList.add('is-animating');
            }
          }
          if (response.ok) {
            _context4.next = 13;
            break;
          }
          console.log(response);
          throw new Error('Network response was not ok');
        case 13:
          _context4.next = 18;
          break;
        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4["catch"](2);
          console.log(_context4.t0);
        case 18:
          _context4.prev = 18;
          return _context4.finish(18);
        case 20:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 15, 18, 20]]);
  }));
  return _fetchProductAndUpdateButton.apply(this, arguments);
}
function getCart() {
  return _getCart.apply(this, arguments);
} // function to add wishlist item to the cart
function _getCart() {
  _getCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var response, data, itemCount, cartDrawer;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return fetch('/cart.js');
        case 3:
          response = _context5.sent;
          if (!response.ok) {
            _context5.next = 10;
            break;
          }
          _context5.next = 7;
          return response.json();
        case 7:
          data = _context5.sent;
          itemCount = data.item_count;
          if (itemCount == 1) {
            window.location.reload();
          } else {
            cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
              bubbles: false
            }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', {
              bubbles: true
            }));
          }
        case 10:
          if (response.ok) {
            _context5.next = 13;
            break;
          }
          console.log(response);
          throw new Error('Network response was not ok');
        case 13:
          _context5.next = 18;
          break;
        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5["catch"](0);
          console.log(_context5.t0);
        case 18:
          _context5.prev = 18;
          return _context5.finish(18);
        case 20:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 15, 18, 20]]);
  }));
  return _getCart.apply(this, arguments);
}
function AddToCart(_x) {
  return _AddToCart.apply(this, arguments);
} // function to render wishlist items. It is called in the connectedCallback of the WishlistElementsWrapper class and in the remove item class
function _AddToCart() {
  _AddToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(FormData) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(FormData)
          });
        case 3:
          response = _context6.sent;
          if (!response.ok) {
            _context6.next = 8;
            break;
          }
          _context6.next = 7;
          return response.json();
        case 7:
          data = _context6.sent;
        case 8:
          if (response.ok) {
            _context6.next = 11;
            break;
          }
          console.log(response);
          throw new Error('Network response was not ok');
        case 11:
          _context6.next = 16;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          console.log(_context6.t0);
        case 16:
          _context6.prev = 16;
          // call the getcart function
          getCart();
          return _context6.finish(16);
        case 19:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13, 16, 19]]);
  }));
  return _AddToCart.apply(this, arguments);
}
function renderWishList(_x2) {
  return _renderWishList.apply(this, arguments);
} // function to render the wishlist module
function _renderWishList() {
  _renderWishList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(wishlistItems) {
    var itemHTML, _iterator5, _step5, item, handle, productUrl, status, text, availability, color;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          console.log(wishlistItems);
          itemHTML = '';
          _iterator5 = _createForOfIteratorHelper(wishlistItems);
          _context7.prev = 3;
          _iterator5.s();
        case 5:
          if ((_step5 = _iterator5.n()).done) {
            _context7.next = 21;
            break;
          }
          item = _step5.value;
          handle = item.handle;
          productUrl = "/products/".concat(handle); // api call to get the newest product data
          _context7.next = 11;
          return getProductData(productUrl, item.id);
        case 11:
          status = _context7.sent;
          text = void 0;
          availability = void 0;
          color = void 0;
          text = status ? 'Tilføj til kurv' : 'Udsolgt';
          availability = status ? '' : 'disabled';
          color = status ? 'tw-bg-[#196450]' : 'tw-bg-[#6b6b6b]';
          itemHTML += "<a href=\"".concat(item.url, "\" data-id=\"").concat(item.id, "\" data-handle=\"").concat(item.handle, "\" class=\"wishlist-item\">\n      <div class=\"wishlist-item-info tw-text-center\">\n        <div class=\"tw-relative\">\n          <img class=\"tw-object-contain\" style=\"--wh-ratio: 1.0;\" src=\"").concat(item.images, "\" alt=\"").concat(item.title, "\" />\n          <wishlist-add_to_cart data-id=\"").concat(item.id, "\">\n            <button class=\"tw-absolute tw-text-[13px] tw-uppercase tw-tracking-[1px] tw-font-bold ").concat(color, " tw-px-[24px] tw-py-[12px] tw-text-white tw-w-full tw-flex tw-justify-center tw-bottom-0 tw-text-center\" ").concat(availability, ">").concat(text, "</button>\n          </wishlist-add_to_cart>\n          </div>\n        <h3 class=\"tw-text-[14.5px] tw-font-bold !tw-m-0 tw-py-2\">").concat(item.title, "</h3>\n        <p class=\"tw-text-[13px]\">").concat(item.price, " DKK</p>\n        <remove-item class=\"remove-item tw-cursor-pointer tw-text-[12px] tw-underline\">Fjern</remove-item>\n      </div>\n    </a>");
        case 19:
          _context7.next = 5;
          break;
        case 21:
          _context7.next = 26;
          break;
        case 23:
          _context7.prev = 23;
          _context7.t0 = _context7["catch"](3);
          _iterator5.e(_context7.t0);
        case 26:
          _context7.prev = 26;
          _iterator5.f();
          return _context7.finish(26);
        case 29:
          return _context7.abrupt("return", itemHTML);
        case 30:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[3, 23, 26, 29]]);
  }));
  return _renderWishList.apply(this, arguments);
}
function renderWishlistModule() {
  var localWishlistItems = localStorage.getItem('wishlistItems');
  var wishlistItems;
  if (localWishlistItems) {
    wishlistItems = JSON.parse(localWishlistItems);
  } else {
    wishlistItems = [];
  }
  setTimeout(function () {
    var wishlistModule = Array.from(document.querySelectorAll('.wishlist-module'));
    var wishlistSection = Array.from(document.querySelectorAll('.wishlist-section'));
    console.log(wishlistItems.length);
    if (wishlistItems.length > 0) {
      var _iterator = _createForOfIteratorHelper(wishlistSection),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.classList.remove('tw-hidden');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(wishlistModule),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          _item.classList.add('tw-hidden');
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      var _iterator3 = _createForOfIteratorHelper(wishlistSection),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item2 = _step3.value;
          _item2.classList.add('tw-hidden');
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = _createForOfIteratorHelper(wishlistModule),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _item3 = _step4.value;
          _item3.classList.remove('tw-hidden');
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, 1000);
  setTimeout(function () {
    var wishlistCount = document.querySelector('#wishlistCount');
    wishlistCount.innerHTML = wishlistItems.length;
  }, 1500);
}
var WishlistSection = /*#__PURE__*/function (_HTMLElement) {
  function WishlistSection() {
    _classCallCheck(this, WishlistSection);
    return _callSuper(this, WishlistSection);
  }
  _inherits(WishlistSection, _HTMLElement);
  return _createClass(WishlistSection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      renderWishlistModule();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-section', WishlistSection);
var WishlistButton = /*#__PURE__*/function (_HTMLElement2) {
  function WishlistButton() {
    _classCallCheck(this, WishlistButton);
    return _callSuper(this, WishlistButton);
  }
  _inherits(WishlistButton, _HTMLElement2);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      var localWishlistItems = localStorage.getItem('wishlistItems');
      var attributes = this.dataset;
      if (localWishlistItems) {
        var wishlistItems = JSON.parse(localWishlistItems);
        var attributesObject = Object.assign({}, attributes);
        var exists = wishlistItems === null || wishlistItems === void 0 ? void 0 : wishlistItems.some(function (item) {
          return item.id === attributesObject.id;
        });
        // on dom load check if the item exists in the wishlistItems array if it does add the is-animating class to show that the item is already in the wishlist
        if (exists) {
          this.classList.toggle('is-animating');
        }
      }
      setTimeout(function () {
        // on click toggle the is-animating class and add or remove the item from the wishlistItems array based on if it exists or not
        _this.addEventListener('click', function () {
          _this.classList.toggle('is-animating');
          var wishlistModuleBox = document.querySelector('#wishlist-module-box');
          var wishlistModuleImg = wishlistModuleBox.querySelector('#wishlist-module-img');
          var wishlistModuleTitle = wishlistModuleBox.querySelector('#wishlist-module-title');
          var wishlistModuleText = wishlistModuleBox.querySelector('#wishlist-module-text');
          wishlistModuleBox.classList.toggle('randomClassName');
          setTimeout(function () {
            wishlistModuleBox.classList.toggle('randomClassName');
          }, 3000);
          if (localWishlistItems) {
            console.log('localWishlistItems exists');
            // add new object to the wishlistItems array
            var _wishlistItems = JSON.parse(localWishlistItems);
            var _attributesObject = Object.assign({}, attributes);
            var _exists = _wishlistItems === null || _wishlistItems === void 0 ? void 0 : _wishlistItems.some(function (item) {
              return item.id === _attributesObject.id;
            });
            wishlistModuleImg.setAttribute('src', _attributesObject.images);
            wishlistModuleTitle.innerHTML = _attributesObject.title;
            if (!_exists) {
              // add attributes to the wishlistItems array
              _wishlistItems.push(_attributesObject);
              localStorage.setItem('wishlistItems', JSON.stringify(_wishlistItems));
              wishlistModuleText.innerHTML = 'Tilføjet til ønskeliste';
            } else {
              // remove attributes from the wishlistItems array
              var newWishlistItems = _wishlistItems.filter(function (item) {
                return item.id != _attributesObject.id;
              });
              localStorage.setItem('wishlistItems', JSON.stringify(newWishlistItems));
              wishlistModuleText.innerHTML = 'Fjernet fra ønskeliste';
            }
          } else {
            console.log('localWishlistItems does not exist');
            var _wishlistItems2 = [];
            var _attributesObject2 = Object.assign({}, attributes);
            _wishlistItems2.push(_attributesObject2);
            localStorage.setItem('wishlistItems', JSON.stringify(_wishlistItems2));
            wishlistModuleText.innerHTML = 'Tilføjet til ønskeliste';
            wishlistModuleImg.setAttribute('src', _attributesObject2.images);
            wishlistModuleTitle.innerHTML = _attributesObject2.title;
            _wishlistItems2.push(_attributesObject2);
            // update localStorage with the new wishlistItems array
            localStorage.setItem('wishlistItems', JSON.stringify(_wishlistItems2));
          }
          localWishlistItems = localStorage.getItem('wishlistItems');
        });
        // listen for variant change and update the wishlist button and it's attributes - THIS IS HIGHLY DEPENDENT ON THE THEME AND MUST BE UPDATED BASED ON THE THEME
        // The below code is for the theme "Pipeline"
        var fieldSet = document.querySelector('fieldset');
        fieldSet.addEventListener('change', function () {
          // fetch the product
          fetchProductAndUpdateButton();
        });
      }, 1000);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-button', WishlistButton);
var WishlistElementsWrapper = /*#__PURE__*/function (_HTMLElement3) {
  function WishlistElementsWrapper() {
    _classCallCheck(this, WishlistElementsWrapper);
    return _callSuper(this, WishlistElementsWrapper);
  }
  _inherits(WishlistElementsWrapper, _HTMLElement3);
  return _createClass(WishlistElementsWrapper, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var localWishlistItems, wishlistItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              localWishlistItems = localStorage.getItem('wishlistItems');
              wishlistItems = JSON.parse(localWishlistItems);
              _context.t0 = "\n        <div class=\"item-container tw-w-full\">\n          <div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-5 tw-py-[50px]\">\n          ";
              _context.next = 5;
              return renderWishList(wishlistItems);
            case 5:
              _context.t1 = _context.sent;
              this.innerHTML = _context.t0.concat.call(_context.t0, _context.t1, "\n          </div>\n        </div>\n      ");
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-elements-wrapper', WishlistElementsWrapper);
// remove item from wishlist
var RemoveItem = /*#__PURE__*/function (_HTMLElement4) {
  function RemoveItem() {
    _classCallCheck(this, RemoveItem);
    return _callSuper(this, RemoveItem);
  }
  _inherits(RemoveItem, _HTMLElement4);
  return _createClass(RemoveItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var remove_item = document.querySelectorAll('.remove-item');
      remove_item.forEach(function (item) {
        item.addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
            var localWishlistItems, wishlistItems, id, newWishlistItems, wishlistElementsWrapper;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  event.preventDefault();
                  localWishlistItems = localStorage.getItem('wishlistItems');
                  wishlistItems = JSON.parse(localWishlistItems);
                  id = item.parentElement.parentElement.dataset.id;
                  newWishlistItems = wishlistItems.filter(function (item) {
                    return item.id != id;
                  });
                  localStorage.setItem('wishlistItems', JSON.stringify(newWishlistItems));
                  wishlistElementsWrapper = document.querySelector('wishlist-elements-wrapper');
                  _context2.t0 = "\n            <div class=\"item-container tw-w-full\">\n              <div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-5 tw-py-[50px]\">\n                ";
                  _context2.next = 10;
                  return renderWishList(newWishlistItems);
                case 10:
                  _context2.t1 = _context2.sent;
                  wishlistElementsWrapper.innerHTML = _context2.t0.concat.call(_context2.t0, _context2.t1, "\n              </div>\n            </div>\n          ");
                  renderWishlistModule();
                case 13:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x3) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('remove-item', RemoveItem);
var WishlistAddToCart = /*#__PURE__*/function (_HTMLElement5) {
  function WishlistAddToCart() {
    _classCallCheck(this, WishlistAddToCart);
    return _callSuper(this, WishlistAddToCart);
  }
  _inherits(WishlistAddToCart, _HTMLElement5);
  return _createClass(WishlistAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var addToCart = this.querySelector('button');
      addToCart.addEventListener('click', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
          var FormData, localWishlistItems, wishlistItems, itemToRemove, wishlistElementsWrapper;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                event.preventDefault();
                FormData = {
                  items: [{
                    id: _this2.dataset.id,
                    quantity: 1
                  }]
                };
                AddToCart(FormData);
                // remove the item from the wishlistItems
                localWishlistItems = localStorage.getItem('wishlistItems');
                wishlistItems = JSON.parse(localWishlistItems);
                itemToRemove = wishlistItems.filter(function (item) {
                  return item.id != _this2.dataset.id;
                });
                localStorage.setItem('wishlistItems', JSON.stringify(itemToRemove));
                // update the wishlist elements wrapper
                wishlistElementsWrapper = document.querySelector('wishlist-elements-wrapper'); // remove item after 1 second
                _context3.t0 = "\n          <div class=\"item-container tw-w-full\">\n            <div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-5 tw-py-[50px]\">\n              ";
                _context3.next = 11;
                return renderWishList(itemToRemove);
              case 11:
                _context3.t1 = _context3.sent;
                wishlistElementsWrapper.innerHTML = _context3.t0.concat.call(_context3.t0, _context3.t1, "\n            </div>\n          </div>\n        ");
                renderWishlistModule();
              case 14:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-add_to_cart', WishlistAddToCart);
function getProductData(_x5, _x6) {
  return _getProductData.apply(this, arguments);
}
function _getProductData() {
  _getProductData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(url, variantId) {
    var response, data, variants, selectedVariant, status;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return fetch("".concat(url, ".js"));
        case 3:
          response = _context8.sent;
          if (!response.ok) {
            _context8.next = 14;
            break;
          }
          _context8.next = 7;
          return response.json();
        case 7:
          data = _context8.sent;
          variants = data.variants;
          selectedVariant = variants.filter(function (variant) {
            return variant.id == variantId;
          }); // Get get the selected variants availability status
          status = selectedVariant[0].available;
          return _context8.abrupt("return", status);
        case 14:
          console.log(response);
        case 15:
          _context8.next = 20;
          break;
        case 17:
          _context8.prev = 17;
          _context8.t0 = _context8["catch"](0);
          console.log(_context8.t0);
        case 20:
          _context8.prev = 20;
          return _context8.finish(20);
        case 22:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 17, 20, 22]]);
  }));
  return _getProductData.apply(this, arguments);
}
document.addEventListener('DOMContentLoaded', function () {
  var sizeGuideModal = document.getElementById('sizeguide-modal');
  var sizeGuideTriggers = Array.from(document.querySelectorAll('.sizeguide-trigger'));
  console.log(sizeGuideModal);
  console.log(sizeGuideTriggers);
  if (sizeGuideTriggers.length > 0) {
    sizeGuideTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        sizeGuideModal.classList.toggle('modal-active');
      });
    });
  }
});

/***/ }),

/***/ "./resources/scripts/components/GiftWithProduct/GiftWithProduct.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/GiftWithProduct/GiftWithProduct.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GiftWithProduct)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var GiftWithProduct = /*#__PURE__*/function () {
  function GiftWithProduct() {
    _classCallCheck(this, GiftWithProduct);
    _defineProperty(this, "hasTriggered", false);
    this.init = this.init.bind(this);
    this.listenForAddToCart = this.listenForAddToCart.bind(this);
    this.getGiftProduct = this.getGiftProduct.bind(this);
    this.checkForGiftInCart = this.checkForGiftInCart.bind(this);
  }
  return _createClass(GiftWithProduct, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var giftIsInCart;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.checkForGiftInCart();
            case 2:
              giftIsInCart = _context.sent;
              if (giftIsInCart !== true) {
                console.log('Gift is not in cart');
                if (window.allProducts) {
                  this.listenForAddToCart();
                } else {
                  this.listenForCartChange();
                }
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "listenForAddToCart",
    value: function listenForAddToCart() {
      var originalFetch = window.fetch.bind(window);
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      function _fetch() {
        _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
          var response, clone, data, addedProductID;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!url.includes('cart/add')) {
                  _context2.next = 12;
                  break;
                }
                _context2.next = 3;
                return originalFetch(url, options);
              case 3:
                response = _context2.sent;
                clone = response.clone();
                if (!clone.ok) {
                  _context2.next = 11;
                  break;
                }
                _context2.next = 8;
                return clone.json();
              case 8:
                data = _context2.sent;
                addedProductID = data.product_id;
                this.getGiftProduct(addedProductID);
              case 11:
                return _context2.abrupt("return", response);
              case 12:
                return _context2.abrupt("return", originalFetch(url, options));
              case 13:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        return _fetch.apply(this, arguments);
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "listenForCartChange",
    value: function listenForCartChange() {
      document.addEventListener('ed:cart-updated', this.checkCart.bind(this));
    }
  }, {
    key: "checkCart",
    value: function () {
      var _checkCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this = this;
        var response, data, totalCartPrice, gwpThreshold, gwpThresholdNum, giftWithProductModal, giftWithProductModalTriggers, getGiftBtn;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(sessionStorage.getItem('gwpGiftNotAdded') !== 'false')) {
                _context3.next = 18;
                break;
              }
              _context3.prev = 1;
              _context3.next = 4;
              return fetch('/cart.js');
            case 4:
              response = _context3.sent;
              if (!response.ok) {
                _context3.next = 13;
                break;
              }
              _context3.next = 8;
              return response.json();
            case 8:
              data = _context3.sent;
              totalCartPrice = data.total_price;
              gwpThreshold = window.gwp_price;
              gwpThresholdNum = Number(gwpThreshold);
              if (totalCartPrice >= gwpThresholdNum) {
                giftWithProductModal = document.getElementById('gift-with-product-modal');
                giftWithProductModal.classList.toggle('modal-active');
                giftWithProductModalTriggers = Array.from(document.querySelectorAll('.gift-with-product-trigger'));
                giftWithProductModalTriggers.forEach(function (trigger) {
                  trigger.addEventListener('click', function () {
                    giftWithProductModal.classList.toggle('modal-active');
                  });
                });
                getGiftBtn = document.getElementById('get-gift');
                getGiftBtn.addEventListener('click', function () {
                  var formData = {
                    items: []
                  };
                  formData.items.push({
                    id: window.gift,
                    quantity: 1,
                    properties: {
                      Gave: 'Ja'
                    }
                  });
                  _this.addProducts(formData);
                  sessionStorage.setItem('gwpGiftNotAdded', 'false');
                });
              }
            case 13:
              _context3.next = 18;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 15]]);
      }));
      function checkCart() {
        return _checkCart.apply(this, arguments);
      }
      return checkCart;
    }()
  }, {
    key: "getGiftProduct",
    value: function () {
      var _getGiftProduct = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(addedProductID) {
        var _this2 = this;
        var allProductsData, product, giftWithProductModal, giftWithProductModalTriggers, getGiftBtn;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.hasTriggered) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              this.hasTriggered = true;
              allProductsData = window.allProducts; // check if the added product is in the allProductsData (allProductsData is an array of all products in the store)
              product = allProductsData.find(function (product) {
                return product.productID === addedProductID;
              });
              if (product) {
                giftWithProductModal = document.getElementById('gift-with-product-modal');
                giftWithProductModal.classList.toggle('modal-active');
                giftWithProductModalTriggers = Array.from(document.querySelectorAll('.gift-with-product-trigger'));
                giftWithProductModalTriggers.forEach(function (trigger) {
                  trigger.addEventListener('click', function () {
                    giftWithProductModal.classList.toggle('modal-active');
                  });
                });
                getGiftBtn = document.getElementById('get-gift');
                getGiftBtn.addEventListener('click', function () {
                  var formData = {
                    items: []
                  };
                  formData.items.push({
                    id: window.gift,
                    quantity: 1,
                    properties: {
                      Gave: 'Ja'
                    }
                  });
                  _this2.addProducts(formData);
                });
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getGiftProduct(_x3) {
        return _getGiftProduct.apply(this, arguments);
      }
      return getGiftProduct;
    }()
  }, {
    key: "addProducts",
    value: function () {
      var _addProducts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(formData) {
        var response, giftWithProductModal;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 3:
              response = _context5.sent;
              if (response.ok) {
                giftWithProductModal = document.getElementById('gift-with-product-modal');
                giftWithProductModal.classList.toggle('modal-active');
                document.dispatchEvent(new CustomEvent('theme:cart:reload'));
              }
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              console.error(_context5.t0);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 7]]);
      }));
      function addProducts(_x4) {
        return _addProducts.apply(this, arguments);
      }
      return addProducts;
    }()
  }, {
    key: "checkForGiftInCart",
    value: function () {
      var _checkForGiftInCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var response, data, cartItems, giftInCart, properties;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return fetch('/cart.js');
            case 3:
              response = _context6.sent;
              if (!response.ok) {
                _context6.next = 17;
                break;
              }
              _context6.next = 7;
              return response.json();
            case 7:
              data = _context6.sent;
              cartItems = data.items;
              giftInCart = cartItems.find(function (item) {
                return item.id == Number(window.gift);
              });
              if (!giftInCart) {
                _context6.next = 17;
                break;
              }
              properties = giftInCart.properties;
              if (!(properties && properties.Gave === 'Ja')) {
                _context6.next = 16;
                break;
              }
              return _context6.abrupt("return", true);
            case 16:
              return _context6.abrupt("return", false);
            case 17:
              _context6.next = 22;
              break;
            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6["catch"](0);
              console.error(_context6.t0);
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 19]]);
      }));
      function checkForGiftInCart() {
        return _checkForGiftInCart.apply(this, arguments);
      }
      return checkForGiftInCart;
    }()
  }]);
}();

var giftWithProduct = new GiftWithProduct();
giftWithProduct.init();

/***/ }),

/***/ "./resources/scripts/components/InventoryInfo/InventoryInfo.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/InventoryInfo/InventoryInfo.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ InventoryInfo)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InventoryInfo = /*#__PURE__*/function (_HTMLElement) {
  function InventoryInfo() {
    var _this;
    _classCallCheck(this, InventoryInfo);
    _this = _callSuper(this, InventoryInfo);
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    // Stigende id, så kun det NYESTE fetch-svar anvendes (undgår flimmer ved hurtige skift).
    _defineProperty(_this, "requestId", 0);
    _this.updateInventoryInfo = _this.updateInventoryInfo.bind(_this);
    _this.onVariantChange = _this.onVariantChange.bind(_this);
    return _this;
  }
  _inherits(InventoryInfo, _HTMLElement);
  return _createClass(InventoryInfo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      document.addEventListener('theme:variant:change', this.onVariantChange);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Ryd op, så lytteren ikke hober sig op hvis elementet fjernes/genindsættes.
      document.removeEventListener('theme:variant:change', this.onVariantChange);
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(event) {
      var variantId = event.detail && event.detail.variant && event.detail.variant.id;
      if (variantId) {
        this.updateInventoryInfo(variantId);
      }
    }
  }, {
    key: "updateInventoryInfo",
    value: function () {
      var _updateInventoryInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var currentRequest, fetchUrl, response, data, doc, fresh;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.requestId += 1;
              currentRequest = this.requestId;
              _context.prev = 2;
              // Hent produktsiden for DEN valgte variant.
              // - Relativ URL (samme origin) så det også virker på dev-serveren, ikke kun live.
              // - Kun ét '?' — ellers bliver variant-id'et ugyldigt og Shopify falder tilbage
              //   til standard-varianten (så ville fx preorder-boksen forsvinde ved variantskift).
              fetchUrl = "".concat(this.productUrl, "?variant=").concat(id);
              _context.next = 6;
              return fetch(fetchUrl);
            case 6:
              response = _context.sent;
              if (response.ok) {
                _context.next = 9;
                break;
              }
              throw new Error('Failed to fetch inventory info');
            case 9:
              _context.next = 11;
              return response.text();
            case 11:
              data = _context.sent;
              if (!(currentRequest !== this.requestId)) {
                _context.next = 14;
                break;
              }
              return _context.abrupt("return");
            case 14:
              doc = new DOMParser().parseFromString(data, 'text/html');
              fresh = doc.querySelector('inventory-info'); // Opdatér KUN indholdet i stedet for at udskifte selve elementet. Så bevares
              // den ene lytter (intet element-replace → ingen ophobning af lyttere/flimmer).
              if (fresh) {
                this.innerHTML = fresh.innerHTML;
              }
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 19]]);
      }));
      function updateInventoryInfo(_x) {
        return _updateInventoryInfo.apply(this, arguments);
      }
      return updateInventoryInfo;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/PlayerPrint/PlayerPrint.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/PlayerPrint/PlayerPrint.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PlayerPrint)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var PlayerPrint = /*#__PURE__*/function (_HTMLElement) {
  function PlayerPrint() {
    var _this;
    _classCallCheck(this, PlayerPrint);
    _this = _callSuper(this, PlayerPrint);
    _defineProperty(_this, "togglePlayerListElement", void 0);
    _defineProperty(_this, "playerPrintWrapper", void 0);
    _defineProperty(_this, "playerListElement", void 0);
    _defineProperty(_this, "players", void 0);
    _defineProperty(_this, "productContainer", void 0);
    _defineProperty(_this, "variantSelectors", void 0);
    _defineProperty(_this, "media", void 0);
    _defineProperty(_this, "mediaFirst", void 0);
    _defineProperty(_this, "mediaSecond", void 0);
    _defineProperty(_this, "mediaFirstSrc", void 0);
    _defineProperty(_this, "mediaSecondSrc", void 0);
    _defineProperty(_this, "selectedPlayer", void 0);
    // Spillertryk-data der venter på at hovedproduktet er tilføjet (sekventering, undgår race).
    _defineProperty(_this, "pendingPrint", null);
    _defineProperty(_this, "pendingTimer", void 0);
    _this.handleAddToCart = _this.handleAddToCart.bind(_this);
    return _this;
  }
  _inherits(PlayerPrint, _HTMLElement);
  return _createClass(PlayerPrint, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.defineElements();
      this.addEventListeners();
    }
  }, {
    key: "defineElements",
    value: function defineElements() {
      this.playerPrintWrapper = this.querySelector('#player-print');
      this.togglePlayerListElement = this.querySelector('#toggle_player-list');
      this.playerListElement = this.querySelector('#player-list');
      this.players = Array.from(this.querySelectorAll('.player'));
      if (this.togglePlayerListElement) {
        this.togglePlayerListElement.style.borderBottom = '1px solid #E3E3E3';
      }
      this.productContainer = this.closest('.product-section');
      this.variantSelectors = Array.from(this.querySelectorAll('.player_print-option'));
      // Null-sikret: nogle produkter har færre end 2 billeder. Tidligere kastede
      // this.media[1].querySelector(...) en fejl her, som afbrød connectedCallback,
      // så addEventListeners() aldrig kørte og spillerlisten aldrig blev vist.
      // (Felterne bruges kun af toggleMedia, som er slået fra — men vi sætter dem sikkert.)
      this.media = Array.from(this.productContainer.querySelectorAll('.product__media'));
      this.mediaFirst = this.media[0] ? this.media[0].querySelector('img') : null;
      this.mediaSecond = this.media[1] ? this.media[1].querySelector('img') : null;
      this.mediaFirstSrc = this.mediaFirst ? this.mediaFirst.getAttribute('src') : '';
      this.mediaSecondSrc = this.mediaSecond ? this.mediaSecond.getAttribute('src') : '';
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener('playerPrintDeselected', function () {
        _this2.selectedPlayer = null;
        // disable media change until data is updated with images
        // this.toggleMedia(false);
      });
      // Når hovedproduktet er tilføjet, udsender temaet 'theme:cart:change'. Først DÉR
      // tilføjer vi spillertrykket — så de to /cart/add-kald ikke racer på en tom kurv
      // (ellers kunne hovedproduktet tabe på den allerførste tilføjelse).
      document.addEventListener('theme:cart:change', function () {
        if (!_this2.pendingPrint) {
          return;
        }
        var data = _this2.pendingPrint;
        _this2.pendingPrint = null;
        clearTimeout(_this2.pendingTimer);
        _this2.handleAddToCart(data);
      });
      this.togglePlayerListElement.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.togglePlayerList();
      });
      this.players.forEach(function (player) {
        player.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handlePlayerSelection(player);
        });
      });
      this.variantSelectors.forEach(function (selector) {
        selector.addEventListener('change', function (event) {
          _this2.handleVariantChange(event);
        });
      });
      // Add event listener for the add to cart button
      var addToCartButton = this.productContainer.querySelector('[data-add-to-cart]');
      if (addToCartButton) {
        addToCartButton.addEventListener('click', function () {
          var _this2$productContain, _this2$productContain2;
          // Læs spiller-valget på KLIK-tidspunktet — ikke om 500ms. Et cart-/variant-
          // re-render kan nå at nulstille this.selectedPlayer (via playerPrintDeselected)
          // inden timeouten kører. Vi fanger derfor data nu, og bruger DOM'ens
          // .player.selected som ekstra sikring hvis variablen er blevet nulstillet.
          var checked = document.querySelector('input[name="player_print"]:checked');
          var isPlayerMode = !!checked && checked.value === 'player';
          var player = _this2.selectedPlayer || _this2.querySelector('.player.selected');
          if (!isPlayerMode || !player) {
            _this2.pendingPrint = null; // intet spillertryk valgt → kun hovedproduktet tilføjes
            return;
          }
          // Gem trykket — det tilføjes når 'theme:cart:change' bekræfter at hovedproduktet er i kurven.
          _this2.pendingPrint = {
            variantId: player.dataset.variantid,
            title: (_this2$productContain = _this2.productContainer.querySelector('.product__title')) === null || _this2$productContain === void 0 || (_this2$productContain = _this2$productContain.textContent) === null || _this2$productContain === void 0 ? void 0 : _this2$productContain.trim(),
            size: (_this2$productContain2 = _this2.productContainer.querySelector('[data-option-value]')) === null || _this2$productContain2 === void 0 || (_this2$productContain2 = _this2$productContain2.textContent) === null || _this2$productContain2 === void 0 ? void 0 : _this2$productContain2.trim()
          };
          // Sikkerhedsnet: hvis hovedproduktet aldrig tilføjes (fx udsolgt), så drop
          // det ventende tryk efter et stykke tid, så det ikke lander ved en senere kurv-ændring.
          clearTimeout(_this2.pendingTimer);
          _this2.pendingTimer = window.setTimeout(function () {
            _this2.pendingPrint = null;
          }, 8000);
        });
      }
    }
  }, {
    key: "togglePlayerList",
    value: function togglePlayerList() {
      this.playerListElement.classList.toggle('active');
      var arrowDown = this.togglePlayerListElement.querySelector('.lucide-chevron-down');
      var arrowUp = this.togglePlayerListElement.querySelector('.lucide-chevron-up');
      var playerListTextElement = this.togglePlayerListElement.querySelector('#toggle_player-list-text');
      var defaultText = playerListTextElement.getAttribute('data-text') || 'Vælg spiller';
      arrowDown.classList.toggle('tw-hidden');
      arrowUp.classList.toggle('tw-hidden');
      if (this.playerListElement.classList.contains('active')) {
        this.togglePlayerListElement.style.borderBottom = '1px solid #E3E3E3';
        playerListTextElement.textContent = defaultText;
      } else {
        this.togglePlayerListElement.style.borderBottom = 'none';
        if (this.selectedPlayer) {
          console.log('Selected player:', this.selectedPlayer); // Debug log for selected player
          var playerName = this.selectedPlayer.dataset.name;
          var playerNumber = this.selectedPlayer.dataset.number;
          var playerDisplay = playerNumber ? "".concat(playerNumber, ". ").concat(playerName) : playerName;
          playerListTextElement.textContent = playerDisplay;
        }
      }
    }
  }, {
    key: "handlePlayerSelection",
    value: function handlePlayerSelection(player) {
      this.players.forEach(function (p) {
        p.classList.remove('selected');
      });
      player.classList.add('selected');
      this.selectedPlayer = player;
      // disable media change until data is updated with images
      // this.toggleMedia(true);
      this.togglePlayerList();
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var target = event.target;
      var value = target.value;
      var printVariantSelected = value === 'player';
      printVariantSelected ? this.playerPrintWrapper.classList.remove('tw-hidden') : this.playerPrintWrapper.classList.add('tw-hidden');
      // disable media change until data is updated with images
      // this.toggleMedia(printVariantSelected);
    }
  }, {
    key: "toggleMedia",
    value: function toggleMedia(printVariantSelected) {
      if (!printVariantSelected) {
        this.mediaFirst.setAttribute('src', this.mediaFirstSrc);
        this.mediaFirst.setAttribute('srcset', this.mediaFirstSrc);
        this.mediaSecond.setAttribute('src', this.mediaSecondSrc);
        this.mediaSecond.setAttribute('srcset', this.mediaSecondSrc);
      }
      if (printVariantSelected && this.selectedPlayer) {
        var firstMediaPlayer = this.selectedPlayer.dataset.frontimage;
        var secondMediaPlayer = this.selectedPlayer.dataset.backimage;
        this.mediaFirst.setAttribute('src', firstMediaPlayer);
        this.mediaFirst.setAttribute('srcset', firstMediaPlayer);
        this.mediaSecond.setAttribute('src', secondMediaPlayer);
        this.mediaSecond.setAttribute('srcset', secondMediaPlayer);
      }
    }
  }, {
    key: "handleAddToCart",
    value: function () {
      var _handleAddToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(printData) {
        var formData, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!printData || !printData.variantId)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              formData = {
                items: [{
                  id: printData.variantId,
                  quantity: 1,
                  properties: {
                    'Tilhørende trøje': printData.title || 'Unknown',
                    Størrelse: printData.size
                  }
                }]
              };
              _context.next = 6;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 6:
              response = _context.sent;
              if (response.ok) {
                document.dispatchEvent(new CustomEvent('theme:cart:reload', {
                  bubbles: true
                }));
              } else {
                console.error('Failed to add player print to cart. Status:', response.status);
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error('Error adding player print to cart:', _context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10]]);
      }));
      function handleAddToCart(_x) {
        return _handleAddToCart.apply(this, arguments);
      }
      return handleAddToCart;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkklovershoppen"] = self["webpackChunkklovershoppen"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;